module.exports = __webpack_public_path__ + "static/media/paypal_confirm_mail.7ccce3e4.png";